module.exports = "\r\n        <div style=\"text-align:center;width: 100%;color:#c62828 \">\r\n            No Records Found\r\n        </div>\r\n"